import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { DriversService } from '@services/drivers.service';
import {
  loadDriversGroups,
  loadDriversGroupsFailure,
  loadDriversGroupsSuccess,
} from '@store/driversGroups/driversGroups.actions';

@Injectable()
export class DriversGroupsEffects {
  private readonly actions$ = inject(Actions);
  private readonly driversService = inject(DriversService);

  loadDriversGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDriversGroups),
      mergeMap(() =>
        this.driversService.driversGroupList().pipe(
          map((list) => loadDriversGroupsSuccess({ list })),
          catchError((error) => of(loadDriversGroupsFailure({ error: error.message }))),
        ),
      ),
    ),
  );
}
